import React from 'react';
import type { ColDef, EditableCallbackParams } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import { getRatingCompanies, saveBatchRatingCompanies } from '../../api/ratingCompanies';
import type { RatingCompany } from '../../types/RatingCompany';
import { t } from '../../i18n/t';

const columnDefs: ColDef<RatingCompany>[] = [
  {
    field: 'ratingCompanyId',
    headerName: t('ratingCompanies.columns.ratingCompanyId'),
    width: 140,
    cellDataType: 'number',
    editable: (params: EditableCallbackParams<RatingCompany>) =>
      (params.data as { __status?: string } | undefined)?.__status === 'added',
    sort: 'asc',
  },
  {
    field: 'ratingCompanyName',
    headerName: t('ratingCompanies.columns.ratingCompanyName'),
    flex: 1,
    editable: true,
  },
];

const newRowDefaults = (): Partial<RatingCompany> => ({
  ratingCompanyId: 0,
  ratingCompanyName: '',
});

export function RatingCompaniesPage() {
  return (
    <LopCrudPage<RatingCompany>
      resourceCode="ratingCompanies"
      titleKey="ratingCompanies.pageTitle"
      idField="ratingCompanyId"
      getRows={getRatingCompanies}
      saveBatch={(added, modified, deletedIds) =>
        saveBatchRatingCompanies(added, modified, deletedIds as number[])
      }
      columnDefs={columnDefs}
      newRowDefaults={newRowDefaults}
    />
  );
}
